import { NextjsOptions } from '@sentry/nextjs/types/utils/nextjsOptions';
import getNextConfig from './../../constants/getNextConfig';

const { appEnv, sentryDsn } = getNextConfig().publicRuntimeConfig;

export interface InitSentryOptions {
  sampleRate?: number;
  application: string;
}

/**
 * Technically this returns a Partial<NextjsOptions>,
 * but I couldn't figure out how to make NextjsOptions scopeable.
 * @param options
 * @returns Value to use in both client and server as a default.
 */
const getSharedConfig: (
  options: InitSentryOptions
) => NextjsOptions = options => ({
  // https://docs.sentry.io/platforms/javascript/performance/
  tracesSampleRate: 0.025,

  enabled: 'production,staging,development'.indexOf(appEnv) !== -1,
  dsn: sentryDsn,
  environment: appEnv,
  sampleRate: options?.sampleRate ?? 1
  //debug: true
});

export default getSharedConfig;
